module.exports = "<div class=\"row\">\n  <div class=\"col-md-12\">\n    <app-main-body></app-main-body>\n    \n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// G:/phoneinfo2/phoneinfo/src/app/components/dashboard/dashboard.component.html
// module id = ../../../../../src/app/components/dashboard/dashboard.component.html
// module chunks = main